import {Component, Input, OnInit} from '@angular/core';
import {QueryResourceInterface} from '../../../core/models/query-resource.interface';
import {SiteLayoutComponent} from '../../../core/layout/site/site-layout.component';
import {Router} from '@angular/router';
import {HashtagRoutingService} from "../../../core/services/hashtag-routing.service";
import {PostTypeEnum} from "../../../core/enums/post-type.enum";

@Component({
  selector: 'app-search-tile',
  templateUrl: './search-tile.component.html',
  styleUrls: ['./search-tile.component.scss']
})
export class SearchTileComponent implements OnInit {
  public readonly PostTypeEnum = PostTypeEnum;

  get hasLastQueriedResources(): boolean {
    return this.appMain.queryService.hasLastQueriedResources;
  }

  @Input() public resource: QueryResourceInterface;
  constructor(
    private readonly appMain: SiteLayoutComponent,
    private readonly router: Router,
    private readonly hashtagRouting: HashtagRoutingService
  ) { }

  ngOnInit(): void {
  }

  public getPostTypeIcon(postType?: string): string {
    switch (postType) {
      case PostTypeEnum.PROJECT_POST:
        return 'pi pi-car';
      case PostTypeEnum.PROJECT_MEDIA_POST:
      case PostTypeEnum.EVENT_MEDIA_POST:
        return 'pi pi-image';
      case PostTypeEnum.EVENT_DISCUSSION_POST:
        return 'pi pi-calendar-plus';
      case PostTypeEnum.HISTORY_POST:
        return 'pi pi-history';
      case PostTypeEnum.DESCRIPTION_POST:
        return 'pi pi-file-edit';
      case PostTypeEnum.SIMPLE_POST:
      default:
        return 'pi pi-user';
    }
  }

  public isCollaborationPost(resource: QueryResourceInterface): boolean {
    return !!(resource.renderData?.collaborationSlug
      || resource.renderData?.collaborationTitle
      || resource.renderData?.collaborationOwnerUsername
      || resource.renderData?.collaborationCollaboratorUsername);
  }

  public getPostContextLabel(resource: QueryResourceInterface): string | null {
    return resource.renderData?.projectVehicleIdentity
      || resource.renderData?.collaborationProjectVehicleIdentity
      || resource.renderData?.eventName
      || null;
  }

  public getPostAlias(resource: QueryResourceInterface): string | null {
    return resource.renderData?.projectAlias
      || resource.renderData?.collaborationProjectAlias
      || null;
  }

  public getPostContextSuffix(resource: QueryResourceInterface): string | null {
    if (this.isCollaborationPost(resource)) {
      return null;
    }

    return resource.renderData?.username || null;
  }

  public getCollaborationUsersLabel(resource: QueryResourceInterface): string | null {
    const owner = resource.renderData?.collaborationOwnerUsername
      || resource.renderData?.projectOwnerUsername
      || null;
    const collaborator = resource.renderData?.collaborationCollaboratorUsername || null;
    if (owner && collaborator) {
      return `${owner} x ${collaborator}`;
    }
    if (owner) {
      return owner;
    }
    if (collaborator) {
      return collaborator;
    }

    return null;
  }

  public getTargetUri(resource: QueryResourceInterface): string | null {
    return (resource?.type === 'hashtag'
      ? this.hashtagRouting.buildTagPath(resource?.slug || resource?.name)
      : resource?.uri) || null;
  }

  goToPage(resource: QueryResourceInterface, event?: MouseEvent): void {
    if (event && (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0)) {
      return;
    }
    event?.preventDefault();
    const targetUri = this.getTargetUri(resource);
    if (!targetUri) {
      return;
    }
    this.router.navigateByUrl(targetUri).then(() => {
      this.appMain.searchMenuClick = false;
      if (resource.type === 'user' || resource.type === 'project' || resource.type === 'event' || resource.type === 'marketplace' || resource.type === 'post') {
        this.appMain.queryService.createLog(this.appMain.user, resource).subscribe(() => {
        });
      }
    });
  }

  removeSearchLog(event: MouseEvent, resource: QueryResourceInterface): void {
    event.preventDefault();
    event.stopPropagation();
    this.appMain.queryService.removeSearchLog(resource).subscribe(() => {
      this.appMain.queryService.resources = this.appMain.queryService.resources.filter(e => e !== resource);
    });
  }
}
